import { enableBodyScroll, disableBodyScroll } from '~js/utils/dom';
import MenuImageListSwiper from '~js/utils/menu-list-swiper';

const MobileMenuOverlay = {
  openMobileMenuCTA: null,
  mobileMenuOverlayContainer: null,
  mobileMenuOverlay: null,
  mobileMenuOverlayCloseCTA: null,
  nestedDrawerOpenCTA: null,
  nestedDrawerCloseCTA: null,
  nestedDrawerBackCTA: null,
  imagesCarouselConatainer: null,

  init() {
    this.initiliaseElement();
    this.initialiseMobileOverlayEvents();
  },

  initiliaseElement() {
    this.openMobileMenuCTA = document.querySelector('.js-mobile-menu-cta');
    this.mobileMenuOverlayContainer = document?.querySelector(
      '.js-mobile-menu-overlay-container',
    );
    this.mobileMenuOverlay = document?.querySelector('.js-mobile-menu-overlay');
    this.mobileMenuOverlayCloseCTA = this.mobileMenuOverlay?.querySelectorAll(
      '.js-mobile-menu-overlay-close-btn',
    );
    this.nestedDrawerOpenCTA = this.mobileMenuOverlay?.querySelectorAll(
      '.js-nested-menu-trigger',
    );
    this.nestedDrawerBackCTA = this.mobileMenuOverlay?.querySelectorAll(
      '.js-nested-menu-back-btn',
    );
    this.imagesCarouselConatainer = this.mobileMenuOverlay?.querySelector(
      '.js-mega-menu-carousel-container',
    );
  },

  initialiseMobileOverlayEvents() {
    if (this.openMobileMenuCTA != null) {
      this.openMobileMenuCTA?.addEventListener('click', () => {
        this.showMenu();
        this.menuImageCarousel();
      });
    }
    if (this.mobileMenuOverlayCloseCTA != null) {
      this.mobileMenuOverlayCloseCTA.forEach((closeCTA) => {
        closeCTA?.addEventListener('click', () => {
          this.hideMenu();
        });
      });
    }

    if (this.nestedDrawerOpenCTA != null) {
      this.nestedDrawerOpenCTA.forEach((button) => {
        button?.addEventListener('click', (e) => {
          e.preventDefault();
          this.opendNestedDrawer(button);
        });
      });
    }

    if (this.nestedDrawerBackCTA != null) {
      this.nestedDrawerBackCTA.forEach((button) => {
        button?.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeNestedDrawer(button);
        });
      });
    }

    this.mobileMenuOverlayContainer.addEventListener('click', () => {
      this.hideMenu();
    });
  },

  showMenu() {
    disableBodyScroll();
    this.mobileMenuOverlayContainer?.classList?.add('is-mobile-menu-open');
    this.mobileMenuOverlay?.classList?.add('is-mobile-menu-open');
  },

  menuImageCarousel() {
    MenuImageListSwiper('.js-mega-menu-carousel-container', 1.411, 20);
  },

  hideMenu() {
    this.mobileMenuOverlayContainer?.classList?.remove('is-mobile-menu-open');
    this.mobileMenuOverlay?.classList?.remove('is-mobile-menu-open');
    enableBodyScroll();
  },

  opendNestedDrawer(button) {
    const targetId = button?.getAttribute('data-target');
    const targetDrawer = document?.getElementById(targetId);
    if (targetDrawer) {
      targetDrawer?.classList?.add('is-nested-drawer-opened');
      this.imagesCarouselConatainer.classList.add('hidden');
    }
  },

  closeNestedDrawer(button) {
    const targetDrawer = button?.closest('.js-nested-menu');
    if (targetDrawer) {
      targetDrawer?.classList?.remove('is-nested-drawer-opened');
    }
    this.imagesCarouselConatainer.classList.remove('hidden');
  },
};

export default MobileMenuOverlay;
